import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// API separada para garçom (usa garcom_token)
export const garcomApi = axios.create({ baseURL: BASE });

garcomApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('garcom_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

garcomApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('garcom_token');
      localStorage.removeItem('garcom_info');
      if (window.location.pathname.startsWith('/garcom')) {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
